import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import Pagination from '../Pagination'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import ReasonReportList from './ReasonReportList'
import ReasonReportEdit from './ReasonReportEdit'
import ReasonReportAdd from './ReasonReportAdd'

const ReasonReport = () => {
  // categories-states
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const manager = user?.permission?.find(e => e.manager === 'property_category_manager') ?? {}
  const [page, setPage] = useState(1)
  const [reasonReportAdd, setReasonReportAdd] = useState(false)
  const [categoryEdit, setCategoryEdit] = useState(false)
  const [currentItem, setCurrentItem] = useState('')
  const [categoryView, setCurrentView] = useState(false)
  // const [isReset, setIsReset] = useState(false)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })

  const [reasonReportList, setReasonReportList] = useState([])
  const [sort, setSort] = useState({
    sort_key: 'createdAt',
    sort_type: 'desc'
  })

  const handleEdit = (item) => {
    setCurrentItem(item)
    setCategoryEdit(!categoryEdit)
  }

  const handlePageClick = (event) => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const handleView = (item) => {
    setCurrentItem(item)
    setCurrentView(!categoryView)
  }

  const handleCategory = () => {
    setReasonReportAdd(!reasonReportAdd)
  }

  const allReasonReport = async (data) => {
    try {
      const payload = {
        page
      }

      var path = apiPath.reasonReportList
      const result = await apiGet(path, payload)
      // if (result?.data?.success) {
      var response = result?.data?.results
      const resultStatus = result?.data?.success
      setReasonReportList(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
      // }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }

  useEffect(() => {
    allReasonReport()
  }, [page, sort])

  return (
    <>
      <div className='bg-white'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] '>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3'>
              <div className='2xl:ml-auto xl:ml-0 lg:pt-0 pt-2'>
                <label
                  for='default-search'
                  className='mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white'
                >
                  {t('O_SEARCH')}
                </label>
                <div className='flex'>
                  {(manager?.add ||
                    user?.role === 'admin') && (
                      <button
                        title='Add Report Reason'
                        type='button'
                        className='bg-[#8FC150] flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap'
                        onClick={() => handleCategory()}
                      >
                        + Add Report Reason
                      </button>)}
                </div>
              </div>
            </form>

            <ReasonReportList
              reasonReportList={reasonReportList}
              page={page}
              allReasonReport={allReasonReport}
              handleEdit={handleEdit}
              handleView={handleView}
              currentItem={currentItem}
              categoryView={categoryView}
              setSort={setSort}
              sort={sort}
              manager={manager}
              paginationObj={paginationObj}
            />
            {/* {categoryView && (
              <SubCategoryView
                categoryView={categoryView}
                currentItem={currentItem}
                handleView={handleView}
                allReasonReport={allReasonReport}
              />
            )} */}

            {categoryEdit && (
              <ReasonReportEdit
                allReasonReport={allReasonReport}
                handleEdit={handleEdit}
                currentItem={currentItem}
                reasonReportList={reasonReportList}
              />
            )}

            {reasonReportAdd && (
              <ReasonReportAdd
                reasonReportAdd={reasonReportAdd}
                allReasonReport={allReasonReport}
                handleCategory={handleCategory}
                reasonReportList={reasonReportList}

              />
            )}
            {paginationObj?.totalItems?.length !== 0 && (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default ReasonReport